import * as TradingView from '#/vendor/charting_library';

import { c00A06E, cAC004E } from '#/colors';
//
const COLOR_UP = c00A06E;
const COLOR_DOWN = cAC004E;

export const MAIN_STYLES: TradingView.Overrides = {
  'paneProperties.backgroundType': 'solid',
  'paneProperties.background': '#07071D',

  // Crosshair
  'paneProperties.crossHairProperties.transparency': 50,

  // Candles styles
  'mainSeriesProperties.candleStyle.upColor': COLOR_UP,
  'mainSeriesProperties.candleStyle.downColor': COLOR_DOWN,
  'mainSeriesProperties.candleStyle.drawWick': true,
  'mainSeriesProperties.candleStyle.drawBorder': true,
  'mainSeriesProperties.candleStyle.borderUpColor': COLOR_UP,
  'mainSeriesProperties.candleStyle.borderDownColor': COLOR_DOWN,
  'mainSeriesProperties.candleStyle.wickUpColor': COLOR_UP,
  'mainSeriesProperties.candleStyle.wickDownColor': COLOR_DOWN,
  'mainSeriesProperties.candleStyle.barColorsOnPrevClose': false,
  'mainSeriesProperties.candleStyle.drawBody': true,

  // Hollow Candles styles
  'mainSeriesProperties.hollowCandleStyle.upColor': COLOR_UP,
  'mainSeriesProperties.hollowCandleStyle.downColor': COLOR_DOWN,
  'mainSeriesProperties.hollowCandleStyle.drawWick': true,
  'mainSeriesProperties.hollowCandleStyle.drawBorder': true,
  'mainSeriesProperties.hollowCandleStyle.borderUpColor': COLOR_UP,
  'mainSeriesProperties.hollowCandleStyle.borderDownColor': COLOR_DOWN,
  'mainSeriesProperties.hollowCandleStyle.wickUpColor': COLOR_UP,
  'mainSeriesProperties.hollowCandleStyle.wickDownColor': COLOR_DOWN,
  'mainSeriesProperties.hollowCandleStyle.drawBody': true,

  // Heikin Ashi styles
  'mainSeriesProperties.haStyle.upColor': COLOR_UP,
  'mainSeriesProperties.haStyle.downColor': COLOR_DOWN,
  'mainSeriesProperties.haStyle.drawWick': true,
  'mainSeriesProperties.haStyle.drawBorder': true,
  'mainSeriesProperties.haStyle.borderUpColor': COLOR_UP,
  'mainSeriesProperties.haStyle.borderDownColor': COLOR_DOWN,
  'mainSeriesProperties.haStyle.wickUpColor': COLOR_UP,
  'mainSeriesProperties.haStyle.wickDownColor': COLOR_DOWN,
  'mainSeriesProperties.haStyle.barColorsOnPrevClose': false,
  'mainSeriesProperties.haStyle.drawBody': true,

  // Bar styles
  'mainSeriesProperties.barStyle.upColor': COLOR_UP,
  'mainSeriesProperties.barStyle.downColor': COLOR_DOWN,
  'mainSeriesProperties.barStyle.barColorsOnPrevClose': false,
  'mainSeriesProperties.barStyle.dontDrawOpen': false,
  'mainSeriesProperties.barStyle.thinBars': true,

  // Line styles
  'mainSeriesProperties.lineStyle.color': COLOR_UP,
  'mainSeriesProperties.lineStyle.linestyle': 0,
  'mainSeriesProperties.lineStyle.linewidth': 2,
  'mainSeriesProperties.lineStyle.priceSource': 'close',

  // Area styles
  'mainSeriesProperties.areaStyle.color1': COLOR_UP,
  'mainSeriesProperties.areaStyle.color2': COLOR_UP,
  'mainSeriesProperties.areaStyle.linecolor': COLOR_UP,
  'mainSeriesProperties.areaStyle.linestyle': 0,
  'mainSeriesProperties.areaStyle.linewidth': 2,
  'mainSeriesProperties.areaStyle.priceSource': 'close',
  'mainSeriesProperties.areaStyle.transparency': 80,

  // Baseline styles
  'mainSeriesProperties.baselineStyle.baselineColor': 'rgba( 117, 134, 150, 1)',
  'mainSeriesProperties.baselineStyle.topFillColor1': COLOR_UP,
  'mainSeriesProperties.baselineStyle.topFillColor2': COLOR_UP,
  'mainSeriesProperties.baselineStyle.bottomFillColor1': COLOR_DOWN,
  'mainSeriesProperties.baselineStyle.bottomFillColor2': COLOR_DOWN,
  'mainSeriesProperties.baselineStyle.topLineColor': COLOR_UP,
  'mainSeriesProperties.baselineStyle.bottomLineColor': COLOR_DOWN,
  'mainSeriesProperties.baselineStyle.topLineWidth': 2,
  'mainSeriesProperties.baselineStyle.bottomLineWidth': 2,
  'mainSeriesProperties.baselineStyle.priceSource': 'close',
  'mainSeriesProperties.baselineStyle.transparency': 40,
  'mainSeriesProperties.baselineStyle.baseLevelPercentage': 50,
};

export const STUDIES_STYLES: TradingView.StudyOverrides = {
  'volume.volume.color.0': COLOR_DOWN,
  'volume.volume.color.1': COLOR_UP,
};

export const LOADING_SCREEN_STYLES: TradingView.LoadingScreenOptions = {
  backgroundColor: '#07071D',
  foregroundColor: '#FFFFFF',
};
